module.exports = __webpack_public_path__ + "vue/img/goszakupki.53043c26.svg";